export default function addRemiseValidation(remiseAAjouter, messages, modulePresseActive) {
  if (!remiseAAjouter.remise) {
    messages.push({
      message: 'editionRemise.discount',
    });
  }
  if (!remiseAAjouter.typeRemise) {
    messages.push({
      message: 'editionRemise.discountType',
    });
  }
  if (!remiseAAjouter.type) {
    messages.push({
      message: 'editionRemise.type',
    });
  }
  if (!remiseAAjouter.libelle && modulePresseActive) {
    messages.push({
      message: 'editionRemise.label',
    });
  }
}
